import { simplePatch } from "../apiConfig"

export const updateTestResult = (id, params) =>
  simplePatch(`/lab/test_results/${id}`, params)

